const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      background: "#1a1a1a",
      color: "rgba(255,255,255,0.92)",
      textAlign: "center",
    }}
    role="alert"
  >
    <div
      style={{
        maxWidth: 380,
        width: "100%",
        padding: "28px 24px",
        borderRadius: 16,
        border: "1px solid rgba(255,255,255,0.1)",
        background: "rgba(255,255,255,0.04)",
      }}
    >
      <p style={{ margin: "0 0 8px", fontWeight: 700 }}>Something went wrong</p>
      <p style={{ margin: "0 0 16px", color: "rgba(255,180,190,0.9)", fontSize: "0.9rem" }}>
        {error?.message || "Unexpected error"}
      </p>
      <button
        type="button"
        className="btn btn-primary btn-sm px-3"
        onClick={resetErrorBoundary}
      >
        Try again
      </button>
    </div>
  </div>
);

export default ErrorFallback;
